import { render, staticRenderFns } from "./ViewOlympicsPredictions.vue?vue&type=template&id=ca388a72&scoped=true&"
import script from "./ViewOlympicsPredictions.vue?vue&type=script&lang=js&"
export * from "./ViewOlympicsPredictions.vue?vue&type=script&lang=js&"
import style0 from "./ViewOlympicsPredictions.vue?vue&type=style&index=0&id=ca388a72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca388a72",
  null
  
)

export default component.exports